$(document).ready(function() {

	// Altura mínima del contenido
	// A resolver posteriormente con CSS
	// Para mejor rendimiento y resultados
	// -----------------------------------
	function calcularAlturaContenido() {
		var alturaCabecera = $('#navegacion').outerHeight();
		var alturaPie = $('#pie').outerHeight();
		var alturaPantalla = window.innerHeight || document.documentElement.clientHeight;
		var margenSuperiorBody = parseFloat($('body').css('margin-top')) || 0;
		var margenInferiorContenido = parseFloat($('.contenido').css('margin-bottom'));
		var alturaMinimaContenido = alturaPantalla - (alturaPie + margenSuperiorBody + margenInferiorContenido);

		// console.log('alturaCabecera: ' + alturaCabecera);
		// console.log('alturaPie: ' + alturaPie);
		// console.log('alturaPantalla: ' + alturaPantalla);
		// console.log('margenSuperiorBody: ' + margenSuperiorBody);
		// console.log('margenInferiorContenido: ' + margenInferiorContenido);
		// console.log('alturaMinimaContenido: ' + alturaMinimaContenido);

		$('.contenido').css('min-height', alturaMinimaContenido + 'px');
	}

	calcularAlturaContenido();

	// Actualizar la altura del contenido si la ventana cambia de tamaño
	$(window).resize(function() {
		calcularAlturaContenido();
	});

	// Boleta de Pronósticos - Reseteo
	// -------------------------------
	$('#boleta input[type="reset"]').on('click', function(event) {
		event.preventDefault();
		$('input[type="radio"]').prop('checked', false);
		$('.alert').hide();
		$('table.table tr').removeClass('table-danger');
	});

});
